import api from './api';

class UnfreezeApiService {
  static BASE_URL = '/unfreeze';

  // Get all sections for medical applications
  static async getSections() {
    try {
      const response = await api.get(`${this.BASE_URL}/sections`);
      return response.data;
    } catch (error) {
      console.error('Error fetching sections:', error);
      throw error;
    }
  }

  // Get all unfreeze records for an application
  static async getUnfreezeRecords(appId, orgId = null) {
    try {
      const params = { appId };
      if (orgId) {
        params.orgId = orgId;
      }
      
      const response = await api.get(`${this.BASE_URL}/records`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching unfreeze records:', error);
      throw error;
    }
  }

   static async pdfRecordInsert(appId) {
    try {
      
      const response = await api.put(`${this.BASE_URL}/pdf-insert`, { appId });
      return response.data;
    } catch (error) {
      console.error('Error fetching unfreeze records:', error);
      throw error;
    }
  }

  // Create new unfreeze record
  static async createUnfreezeRecord(unfreezeData) {
    try {
      const response = await api.post(`${this.BASE_URL}/create`, unfreezeData);
      return response.data;
    } catch (error) {
      console.error('Error creating unfreeze record:', error);
      throw error;
    }
  }

  // Update unfreeze record
  static async updateUnfreezeRecord(id, unfreezeData) {
    try {
      const response = await api.put(`${this.BASE_URL}/update/${id}`, unfreezeData);
      return response.data;
    } catch (error) {
      console.error('Error updating unfreeze record:', error);
      throw error;
    }
  }

  // Delete unfreeze record (soft delete)
  static async deleteUnfreezeRecord(id, userId) {
    try {
      const response = await api.delete(`${this.BASE_URL}/delete/${id}`, {
        data: { userId }
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting unfreeze record:', error);
      throw error;
    }
  }

  // Check if a section is currently unfrozen
  static async checkSectionStatus(appId, orgId, sectionName) {
    try {
      const params = { appId, orgId, sectionName };
      const response = await api.get(`${this.BASE_URL}/check-status`, { params });
      return response.data;
    } catch (error) {
      console.error('Error checking section status:', error);
      throw error;
    }
  }
}

export default UnfreezeApiService;